import { inject, service } from "../../../../../../lib/itn-ui-kit/services/service-container.js";
import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import Template from "./template.jsx";
import useStore from "../../../../../../lib/itn-ui-kit/data/store.js";
import { userDBService } from "../../../../../components/ui library/helpers/dbInstances";
import ApiRequestErrorHandler from "../../../../../components/global/ApiRequestErrorHandler.js";
import { SelectOptionsProCliStatusDataProcessorRole } from "../../../../../components/global/FormComponents/SelectBasic/utils/SelectOptionsProCliStatusDataProcessorRole.js";
import { ENTITY_TYPE_PROVIDER } from "../../../../../../globalConstants.js";
import { useDocumentListStore } from "../../../../../components/modules/Documents/ViewDocuments/hooks/useDocumentListStore.js";

export default class FinanceCasesDetailDocumentsRoute extends BaseRoute {
  @service('repositories/case-folder-repository') folderRepository;
  @service('repositories/document-repository') documentRepository;
  @service('repositories/document-validate-repository') documentValidateRepository;
  @service('repositories/provider-client-status-repository') providerClientStatusRepository;
  @service('repositories/appointment-repository') appointmentRepository;
  @service('repositories/case-repository') caseRepository;

  element = <Template />;

  async loader({ params, request }) {
    const { id } = params;
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());
    const userDetail = await userDBService.get("userDetail");
    const isProvider = userDetail?.entity?.entityTypeLabel === ENTITY_TYPE_PROVIDER;
  
    const folderStore = useDocumentListStore.getState();
    if (!folderStore.folderId) {
      folderStore.setFolderId(1);
    }
  
    const folderId = folderStore.folderId;
  
    const folders = await this.folderRepository.findRecord(id + "/" + folderId);
    const _case = await this.caseRepository.findRecord(id);
    const documentsOpts = await this.documentRepository.getOptions();
    const providersClient = await this.providerClientStatusRepository.query({case: id});
    const providers = providersClient.map((client) => client?.provider);
    const documentValidation = await this.documentValidateRepository.get();
  
    const deleteDocument = async (docId) => await this.documentRepository.delete(docId);
    const patchDocument = async (docId, body) => await this.documentRepository.patch(docId, body);
  
    folderStore.setParentFolderId(folders.parentFolderId);
    folderStore.setTotalDocumentCount(folders.documents.length);
  
    const count = useStore.getState().getTotalCount("document");
  
    let managedProviderOptions = [];
    try {
      if (providersClient?.length > 0) {
        managedProviderOptions = await SelectOptionsProCliStatusDataProcessorRole(
          providersClient,
          isProvider,
          null
        );
      }
    } catch (error) {
      return ApiRequestErrorHandler(error.response);
    }
  
    return {
      _case,
      folders,
      documentsOpts,
      documentValidation,
      providers,
      deleteDocument,
      patchDocument,
      count,
      managedProviderOptions,
    };
  }
  
}